import { Component, OnDestroy, OnInit } from '@angular/core';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, take, takeUntil } from 'rxjs';
import { TemplateRefDiamondsService } from 'src/app/customers/layout/component-layout/profile-character/level-profile/diamonds-popup/template-ref-diamonds.service';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { ModalService } from 'src/app/shareModule/services/modal.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { environment } from 'src/environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
  selector: 'app-around-me',
  templateUrl: './around-me.component.html',
  styleUrls: ['./around-me.component.scss'],
})
export class AroundeMeComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);
  public questList: Array<any> = [];
  playAnimation = true;
  imgUrl: string = environment.ImageUrl;
  tutorials: boolean;

  constructor(
    private local: LocalServiceService,
    private auth: AuthServiceService,
    public sharedService: SharedService,
    private templateRefDiamondsService: TemplateRefDiamondsService,
    private myModalService: ModalService,
    private customerService: CustomerService,
    private toastr: ToastrService
  ) {
    if (this.sharedService.isBrowser()) {
      this.tutorials = JSON.parse(localStorage.getItem('tutorials')) || false;
    }
  }



  onlineMembers: any[] = [];
  aroundMembers: any[] = [];
  showOnlineMembers = false;
  ngOnInit(): void {
    this.local.getUserDetailsObserver()
      .subscribe((user) => {
        if (user?.id) {
          this.getOnlineMember();
        }
      });

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  getOnlineMember() {
    this.customerService.getOnlineMember().subscribe((resp: ApiResponse) => {
      this.aroundMembers = resp.body;
      this.aroundMembers.sort((a: any, b: any) => b.isOnline - a.isOnline)
      this.aroundMembers.map((member) => {
        member.appUser.created = moment.unix(member.appUser.created).format('MMMM D, YYYY')
      });
      this.onlineMembers = this.aroundMembers.filter((row: any) => row.isOnline)
    });
  }

  handleReport(user: any) {
    this.local.alertReport().then((result) => {
      if (result.isConfirmed && result.value) {
        const report = result.value;
        this.auth
          .submitReportMessage({
            message: report.reportDetails,
            type: report.reportType,
            category: "member",
            product_id: user.id,
          })
          .subscribe(
            () => {
              this.toastr.success('Reported successfully');
            },
            (e) => {
              this.toastr.error(e.error.message);
            }
          );
      }
    });
  }

}
